import { LocaleData } from "./Models/Locales.interface"


export const AUTHENTICATION_STATUS = {
  authenticated: 'Authenticated',
  unauthenticated: 'Unathenticated',
  unknown: 'Unknown'
}


export const AlertPositions = {
  bottomCenter:  {
    vertical: 'bottom',
    horizontal: 'center',
  },
  bottomLeft: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  bottomRight: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  topRight: {
    vertical: 'top',
    horizontal: 'right',
  },
  topCenter: {
    vertical: 'top',
    horizontal: 'center',
  },
  topLeft: {
    vertical: 'top',
    horizontal: 'left',
  }
}

export const AlertTypes = {
  error: 'error',
  warning: 'warning',
  info: 'info',
  success: 'success',
  default: 'default'
}

// network contants
// export const baseURL = 'https://itiswritten.tv/api/v1'
export const baseURL = 'https://us-central1-iiwtv-139f6.cloudfunctions.net/v1';
// export const baseURL = 'http://localhost:5001/iiwtv-139f6/us-central1/v1'
export const getVideoURL = (uuid: string) => {
  try{
      // const device = await getSystemName()
      // const version = await getSystemVersion()
      // const model = await getModel()

      const device = ""
      const version = ""
      const model = ""

      return encodeURI(`https://itiswritten.tv/api/v1/player?videoId=${uuid}&device=${device}&version=${version}&model=${model}`)
  } catch {
      return `https://itiswritten.tv/api/v1/player?videoId=${uuid}`
  }   
}
// video_id and program_id = string | number)
export const getVideoShareLink = (video_id, program_id)  => {
  if(program_id){
      return `https://itiswritten.tv/programs/${program_id}/${video_id}`
  }
  else {
      return `https://itiswritten.tv`
  }
  
}



// table names
export const SETTINGS = 'Settings'
export const Network = 'Network'


export const Paths = {
   giveURL: "https://www.itiswritten.com/give",
   donar: "https://escritoesta.org/donar/",
   studiesURL: "https://www.itiswritten.study/home",
   eestudies: "https://www.escritoesta.study/home",
   IIWURL: "https://itiswritten.com",
   EEURL: "https://escritoesta.org",
   impressions: "https://iiw.us/subimpressions",
   viewImpressions: "https://issuu.com/iiwmedia/stacks/e6765a479f15493b98f51a801cbc0a9a",
   eeImpressions: "https://issuu.com/escritoesta/stacks/2f357801af98490b8f5dd5c16891d900",
   eeMejor: "https://escritoesta.org/daily-devotional-signup/",
   EWsignup: "https://www.itiswritten.com/daily-devotional-signup",
   prayer : 'https://iiw.us/prayer',
   oracion : 'https://escritoesta.org/pedidos-de-oracion/',
   englishBlogUrl : 'https://blog.itiswritten.com/wp-json/wp/v2/posts?per_page=15',
   spanishBlogUrl : 'https://escritoesta.org/wp-json/wp/v2/posts'
}

export const EnglishConfig = {
  biblestudy: "Bible Studies",
  aboutus: "About Us",
  subscribe: "Subscribe",
  prayerrequest: "Prayer Request",
  visitiiw: "Visit It Is Written",
  visitee: "Visit Escrito Está",
  language: "Cambiar a Español",
  donate: "Donate",
  home: "Home",
  blog: "Blog",
  programs: "Programs",
  search: "Search",
  searchFor: "Search for",
  live: "Live",
  login: "Log In",
  signIn: "Sign In",
  createAccount: "Create Account",
  menu: "Menu",
  searchResultsFor: "Search results for",
  history: "Watch History",
  continue: "Continue Watching",
  wtw: "What to Watch",
  dd: "Daily Devotionals",
  au1: "It Is Written ",
  sub1: "Keep up-to-date with It Is Written",
  sub2: "Subscribe below to Every Word, It Is Writtens daily devotional from Pastor John Bradshaw, Impressions, It Is Written's new quarterly magazine, available on the web and in print, and It Is Written's weekly email updates",
  sub3: "Impressions",
  updates: "Latest News",
  seeAll: "See All",
  featuredHeader: "This week on It Is Written",
  play: "Play",
  myList: "My List",
  info: "Info",
  addToList: "Add To List",
  copywrite: "© 2020 It Is Written. All rights reserved.",
  terms: "Terms of Use",
  privacy: "Privacy Policy",
  privacyCalifornia: "Your California Privacy Rights",
  sitemap: "Sitemap",
  browse: "Browse",
  aboutUs: "About Us",
  more: "More",
  allEpisodes: "All Episodes",
  miniSeries: "Mini-Series",
  details: "Details",
  notifyMe: "Notify Me",
  onDemand: "On-Demand Programs",
  letsTalk: "Let's Talk",
  contactUsMain:"Hey there!\n\n\
  We're so glad you're on our site and watching our programs. We hope you're enjoying them and are learning something new every day.\n\n\
  If you have any questions, comments, or even prayer requests... don't worry, we're here for you! Just fill out the form below and someone will get back to you as soon as possible.\n\n\
  (Pro Tip: You may want to first visit the Help Section. It's the fastest place to get answers to questions about using this website.)\n\n\
  Talk to you soon!\n\n\
  – Your friends at It Is Written TV",
  contactUsName: "Hi, my name is...",
  contactUsMessage: "Allow me to explain...",
  contactUsEmail: "You can reach me at this email address...",
  contactUsQuestion: "I have a question / comment about...",
  contactUsTypeOrders: "Product Inquiry",
  contactUsTypeSupport: "Technical Support",
  contactUsTypePrayer: "Prayer Request",
  contactUsTypeGeneral: "General Inquiry",
  selectOne: "Select one...",
  contactUsNameError: "We'll need your name.",
  contactUsSelectError: "What type of inquiry is this?",
  contactUsMessageError: "We'll need to know how we can help you.  Please enter your request.",
  contactUsEmailError: "We'll need a valid email to contact you.",
  submit: "Submit"



}  as LocaleData
export const SpanishConfig = {
      
      biblestudy: "Estudios Bíblicos",
      aboutus: "Sobre nosotros",
      subscribe: "Suscríbete",
      prayerrequest: "Pedidos de oración",
      visitiiw: "Visita It Is Written",
      visitee: "Visita Escrito Está",
      language: "Switch to English",
      donate: "Donar",
      home: "Inicio",
      blog: "Noticias",
      programs: "Programas",
      search: "Buscar",
      searchFor: "Buscar",
      live: "Transmisión en Vivo",
      login: "Iniciar Sesión",
      signIn: "Iniciar Sesión",
      createAccount: "Crear una Cuenta",
      menu: "Menú",
      searchResultsFor: 'resultados de búsqueda para',
      history: "Historial de visualizaciones",
      continue: "Sigue Mirando",
      wtw: "Cosas para mirar",
      dd: "Devocionales Diarios",
      au1: "Escrito Está ",
      au2: "es un ministerio profundamente espiritual que se dedica con pasión a la comunicación del Evangelio al mundo. Escrito Está busca producir un impacto en las vidas, a favor de Cristo, de cuatro maneras: por medio del programa semanal, Internet, el ministerio evangelizador mundial, y recursos para compartir la fe y vivir una vida cristiana.",
      au3: "Visión General",
      au4: "Escrito Está es un ministerio cristiano internacional de televisión que se dedica a compartir el entendimiento de la Palabra de Dios con las personas de todo el mundo. Fue fundado en 1956 por George Vandeman, y el lema del ministerio se encuentra en Mateo 4:4: “Escrito está: No sólo de pan vivirá el hombre, sino de toda palabra que sale de la boca de Dios”.",
      au5: "Cada programa semanal aborda verdades perennes y las aplica a la vida diaria. Los programas suelen tratar temas tales como la soledad, el temor, la baja autoestima, la salud, los valores familiares y principios espirituales. Personas de todos los credos y religiones –incluso quienes no tienen ninguna fe—han sido inspiradas y estimuladas por las presentaciones directas y elevadoras de Escrito Está.",
      sub1: "Mantente al día con Escrito Está",
      sub2: "Suscríbete ahora mismo para recibir el devocional diario Una Mejor Manera de Vivir con el pastor Robert Costa.También podrás ver la revista digital Canales de Inspiración.",
      sub3: "Impresiones",
      sub_img: "Impresiones",
      updates: "Últimas Noticias",
      seeAll: "Ver Todo",
      featuredHeader: "Esta Semana en Está Escrita",
      play: "Reproducir",
      myList: "Mi Lista",
      info: "Información",
      addToList: "Agregar a Mi Lista",
      copywrite: "© 2020 It Is Written. All rights reserved.",
      terms: "Condiciones de uso",
      privacy: "Política de privacidad",
      privacyCalifornia: "Sus derechos de privacidad en California",
      sitemap: "Mapa del sitio",
      browse: "Navegar",
      aboutUs: "Sobre Nosotros",
      more: "Más",

      allEpisodes: "Todos los episodios",
      miniSeries: "Serie Pequeña",
      details: "Detalles",
      notifyMe: "Notificarme",

      onDemand: "Programas Bajo Demanda",
      letsTalk: "Hablemos",
      contactUsMain: "¡Saludos!\n\n\
      Gracias por visitar nuestro sitio web. Esperamos que disfrutes la programación y que aprendas algo nuevo cada día.\n\n\
      Si tienes alguna pregunta, comentario o incluso pedidos de oración ... no te preocupes, ¡estamos aquí para ayudarte! Simplemente completa el formulario a continuación y alguien se comunicará contigo lo antes posible.\n\n\
      (Consejo profesional: es posible que desees visitar primero la Sección de ayuda. Es el lugar más rápido para obtener respuestas a preguntas sobre el uso de este sitio web).\n\n\
      ¡Hablamos pronto!\n\n\
      - Tus amigos de Escrito Está",
      contactUsName: "Hola, mi nombre es...",
      contactUsMessage: "Permíteme explicarte...",
      contactUsEmail: "Puede comunicarse conmigo en esta dirección de correo electrónico...",
      contactUsQuestion: "Tengo una pregunta / comentario sobre...",
      contactUsTypeOrders: "Peticiones sobre producto",
      contactUsTypeSupport: "Apoyo técnico",
      contactUsTypePrayer: "Peticiones de oración",
      contactUsTypeGeneral: "Consulta general",
      selectOne: "Seleccione uno...",

      contactUsNameError: "Necesitaremos su nombre.",
      contactUsSelectError: "¿Qué tipo de consulta es esta?",
      contactUsMessageError: "Necesitaremos saber cómo podemos ayudarlo.  Ingrese su solicitud, Por favor",
      contactUsEmailError: "Necesitaremos un correo electrónico válido para comunicarnos con Usted.",
      submit: "Enviar"


} as LocaleData


